import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-white" data-testid="layout-root">
      <Navbar />
      <main className="flex-1" data-testid="layout-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
